import { payOrderApi } from '@/api/order'

/**
 * 支付订单
 * @param {Object} context - Vuex context
 * @param {Object} data - 支付参数
 * @param {string} data.order_sn - 订单编号
 * @param {number} data.pay_type - 支付方式（1:积分 | 2:余额 | 3:微信 | 20:混合 | 21:福利卡 | 23:项目卡）
 * @param {Array} [data.pay_details] - 混合支付明细（混合支付时必填）
 * @param {number} [data.weal_id] - 福利卡 ID
 * @param {number} [data.card_id] - 优惠券卡券 ID
 * @param {number} [data.shop_id] - 新福利卡 ID
 */
const payOrder = async ({ state, getters, dispatch }, data) => {
  const { order_sn, pay_type, pay_details, weal_id, card_id, shop_id } = data

  const result = await payOrderApi({
    order_sn,
    pay_type,
    pay_details: pay_details || undefined,
    weal_id: weal_id || undefined,
    card_id: card_id || undefined,
    shop_id: shop_id || undefined
  })

  return result.data.data
}

export default payOrder
